import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (MultipleValueWidgetTemplate)
// code-splits into its own tpl-multiple-value-widget chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'multiple-value-widget',
    name: 'Multiple Value Widget',
    description: 'This widget can be used to represent multiple values inside boxes.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-multiple-value-widget" */ "./MultipleValueWidgetTemplate")),
    icon: generateIconProp('boxes'),
    complexity: 'easy',
    canDragDropFields: true,
});
